// Customizable Area Start
import React, { Component, createRef } from "react";
import { Box, IconButton, styled } from "@mui/material";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import PauseRoundedIcon from "@mui/icons-material/PauseRounded";
import FullscreenIcon from "@mui/icons-material/Fullscreen";

type Props = {
  url: string;
};

type State = {
  isPlaying: boolean;
};

const VideoWrapper = styled(Box)({
  width: "100%",
  height: "100%",
  position: "relative",
  borderRadius: "6px",
  overflow: "hidden",
  backgroundColor: "#000",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

const BottomLeftControl = styled(IconButton)({
  position: "absolute",
  bottom: 4,
  left: 4,
  backgroundColor: "#ffffffaa",
  padding: 3,
  borderRadius: "50%",
  zIndex: 2,
  "& svg": {
    color: "#0F172A"
  },
  "&:hover": {
    backgroundColor: "#ffffffaa",
  }
});

const BottomRightControl = styled(IconButton)({
  position: "absolute",
  bottom: 4,
  right: 4,
  backgroundColor: "#ffffffaa",
  padding: 3,
  borderRadius: "50%",
  zIndex: 2,
  "& svg": {
    color: "#0F172A"
  },
  "&:hover": {
    backgroundColor: "#ffffffaa",
  }
});

class VideoPreview extends Component<Props, State> {
  videoRef = createRef<HTMLVideoElement>();

  state: State = {
    isPlaying: false,
  };

  togglePlay = () => {
    const video = this.videoRef.current;
    if (!video) return;

    if (this.state.isPlaying) {
      video.pause();
    } else {
      video.play();
    }

    this.setState((prev) => ({ isPlaying: !prev.isPlaying }));
  };

  enterFullscreen = () => {
    const video = this.videoRef.current;
    if (video?.requestFullscreen) {
      video.requestFullscreen();
    }
  };

  render() {
    const { url } = this.props;
    const { isPlaying } = this.state;

    return (
      <VideoWrapper>
        <video
          ref={this.videoRef}
          src={url}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
          muted
          playsInline
          onClick={this.togglePlay}
          onEnded={() => this.setState({ isPlaying: false })}
        />
        <BottomLeftControl size="small" onClick={this.togglePlay}>
          {isPlaying ? (
            <PauseRoundedIcon sx={{ fontSize: 15 }} />
          ) : (
            <PlayArrowRoundedIcon sx={{ fontSize: 15 }} />
          )}
        </BottomLeftControl>
        <BottomRightControl size="small" onClick={this.enterFullscreen}>
          <FullscreenIcon sx={{ fontSize: 15 }} />
        </BottomRightControl>
      </VideoWrapper>
    );
  }
}

export default VideoPreview;
// Customizable Area End
